import React, 
       { useEffect, 
         useState,
         useContext}                from 'react';
import { Container, 
         Button,
         Row, 
         Col}                       from 'react-bootstrap';
import api                          from './AxiosConfig';
import CheckBoxDisplay              from './CheckBoxDisplay';
import DateDisplay                  from './DateDisplay';
import { SelectionContext }         from './SelectionContext';

function GoalProgressUpdateCL( { selGoal, refresh } ) {
  const [goal,           setGoal]            = useState();
  const [checklistItems, setChecklistItems]  = useState();
  const [changedIds,     setChangedIds]      = useState(() => new Set());
  const [message,        setMessage]         = useState( "" );
  const [messageErr,     setMessageErr]      = useState( false );
  const { getExpandedCLSummary }             = useContext(SelectionContext);
       
 useEffect(() => {
    if (selGoal) {
        setGoal(selGoal);
        }
  }, [selGoal]); // Runs when initialData changes

  useEffect(() => {
      async function getChecklistItems() {
          if ( goal && goal.id ) {
              try {
                  const response = await api.get(`/site/checklists/${encodeURIComponent(goal.id)}`, {withCredentials: true });
                  setChecklistItems(response.data);
              } catch (error) {
                  console.log("getGoalProgress: " + error);
              }
          }
      }
      getChecklistItems();
  }, [goal]); 
 
const updateProgressAtIndex = (i, newValue) => {
  setChecklistItems(prev => {
    const current = prev[i];
    if (!current || current.item_complete === newValue) return prev;

    setChangedIds(ids => {
      const next = new Set(ids);
      next.add(current.id);
      return next;
    });

    return prev.map((item, idx) =>
      idx === i ? { ...item, item_complete: newValue } : item
    );
  });
};
       
const handleClick = (i) => {
  const current = checklistItems[i]?.item_complete;
  if (current == null) return;
  updateProgressAtIndex(i, current === 1 ? 0 : 1);
};

const handleUpdateProgressRecord = async () => {
  try {
    const toUpdate = checklistItems.filter(item => changedIds.has(item.id));
    if (toUpdate.length === 0) return;

    let success = true;
    let msg = "";

    for (const item of toUpdate) {
      const response = await api.put(
        `/site/checklists/${encodeURIComponent(goal.id)}/${encodeURIComponent(item.id)}`,
        { checklistItem: item },
        { withCredentials: true }
      );
      msg = response.data.message;
      if (!response.data.success) {
        success = false;
        break;
      }
    }

    setMessage(msg);
    setMessageErr(!success);
    if (success) {
      setChangedIds(new Set());
      refresh();
    }
  } catch (error) {
    console.log("subGoalRow: " + error);
    setMessage(error);
    setMessageErr(true);
  }
};
       
  return (
    <Container className="mt-4">
      { goal && checklistItems ? ( 
      <>
        {checklistItems.map((cl, index) => (
          <><div className="content-container">
            <div class="left-content d-flex align-items-center">
              <span><CheckBoxDisplay checkState={cl.item_complete} index={index} clickHandler={handleClick}/></span>
              <span>{cl.item_description}</span>
            </div>
            <div class="right-content">
               <DateDisplay dateVal={cl.item_due} />     
            </div>
          </div>
          { getExpandedCLSummary() === true && (<div className="content-container">
            <div class="left-content d-flex align-items-center cl-progress-long-desc">
              <span>{cl.item_long_description}</span>
            </div>
          </div>) }</>
          ))}       
          <Row><Col className="text-center"><Button variant="primary" size="sm" onClick={() => handleUpdateProgressRecord()}>
              Update Progress
              </Button></Col></Row>
      </> ) : ( <p>Loading data...</p> )}
      <Row><Col className={'text-center message-err-' + messageErr}>{message}</Col></Row>
    </Container>           
  );
}

export default GoalProgressUpdateCL;
